<template>
  <div>
    <ValidationObserver ref="form">
      <form @submit.prevent="handleSubmit">
        <div class="vx-row">
          <div class="vx-col w-7/12">
            <vx-card class="mb-base" title="Mis datos">
              <div class="vx-row">
                <div class="vx-col w-full">
                  <h4 class="text-uppercase">{{ $t('user.UserInfo') }}</h4>
                </div>
                <div class="vx-col md:w-1/2 w-full">
                  <vx-input-group class="mb-5 mt-3">
                    <ValidationProvider name="Nombre" rules="required|minLength:5" v-slot="{ errors }">
                      <vs-input label-placeholder="Nombre" v-model="userForm.name" required="true" class="w-full" />
                      <p class="text-danger">{{ errors[0] }}</p>
                    </ValidationProvider>
                  </vx-input-group>
                </div>
                <div class="vx-col md:w-1/2 w-full">
                  <vx-input-group class="mb-5 mt-3">
                    <ValidationProvider name="Apellidos" rules="required" v-slot="{ errors }">
                      <vs-input
                        label-placeholder="Apellidos"
                        v-model="userForm.surname"
                        required="true"
                        class="w-full"
                      />
                      <p class="text-danger">{{ errors[0] }}</p>
                    </ValidationProvider>
                  </vx-input-group>
                </div>
                <div class="vx-col md:w-1/2 w-full">
                  <vx-input-group class="mb-5 mt-3">
                    <ValidationProvider name="Correo electrónico" rules="required|email" v-slot="{ errors }">
                      <vs-input
                        label-placeholder="Correo electrónico"
                        v-model="userForm.email"
                        required="true"
                        class="w-full"
                      />
                      <p class="text-danger">{{ errors[0] }}</p>
                    </ValidationProvider>
                  </vx-input-group>
                </div>
                <div class="vx-col md:w-1/2 w-full">
                  <vx-input-group class="mb-5 mt-3">
                    <ValidationProvider name="Teléfono" rules="required" v-slot="{ errors }">
                      <vs-input label-placeholder="Teléfono" v-model="userForm.phone" required="true" class="w-full" />
                      <p class="text-danger">{{ errors[0] }}</p>
                    </ValidationProvider>
                  </vx-input-group>
                </div>
                <div class="vx-col md:w-1/2 w-full">
                  <vx-input-group class="mb-5 mt-3">
                    <ValidationProvider name="Puesto" rules="required" v-slot="{ errors }">
                      <vs-input label-placeholder="Puesto" v-model="userForm.job" required="true" class="w-full" />
                      <p class="text-danger">{{ errors[0] }}</p>
                    </ValidationProvider>
                  </vx-input-group>
                </div>
                <div class="vx-col md:w-1/2 w-full">
                  <vx-input-group class="mb-5 mt-3" v-if="languages">
                    <ValidationProvider name="Lenguaje" rules="required" v-slot="{ errors }">
                      <vs-select autocomplete label="Lenguaje" v-model="userForm.lang" class="selectLang w-full">
                        <vs-select-item :key="index" :value="index" :text="item" v-for="(item, index) in languages" />
                      </vs-select>
                      <p class="text-danger">{{ errors[0] }}</p>
                    </ValidationProvider>
                  </vx-input-group>
                </div>
                <div class="vx-col w-full mb-4">
                  <vs-checkbox v-model="changePassword">{{ $t('ChangePassword') }}</vs-checkbox>
                </div>
                <div v-if="changePassword" class="vx-col w-full">
                  <vx-input-group class="mb-3">
                    <ValidationProvider rules="required" name="Contraseña" v-slot="{ errors }">
                      <vs-input
                        type="password"
                        label-placeholder="Contraseña actual"
                        v-model="userForm.oldPassword"
                        class="w-full"
                      />
                      <p class="text-danger mt-2">{{ errors[0] }}</p>
                    </ValidationProvider>
                  </vx-input-group>
                  <vx-input-group class="mb-3">
                    <ValidationProvider rules="required|min:8|whitespace" name="Nueva contraseña" v-slot="{ errors }">
                      <vs-input
                        type="password"
                        label-placeholder="Nueva contraseña"
                        v-model="userForm.newPassword"
                        class="w-full"
                      />
                      <p class="text-danger mt-2">{{ errors[0] }}</p>
                    </ValidationProvider>
                  </vx-input-group>
                  <vx-input-group class="mb-4">
                    <ValidationProvider
                      name="Confirma nueva contraseña"
                      rules="required|password:@Nueva contraseña"
                      v-slot="{ errors }"
                    >
                      <vs-input
                        type="password"
                        label-placeholder="Confirma nueva contraseña"
                        v-model="userForm.newPassword_confirmation"
                        class="w-full"
                      />
                      <p class="text-danger mt-2">{{ errors[0] }}</p>
                    </ValidationProvider>
                  </vx-input-group>
                </div>
                <div class="vx-col w-full">
                  <vs-button
                    type="filled"
                    color="primary"
                    @click="handleSubmit"
                    class="btn-primary btn--xlarge-auto font-weight-bold"
                  >
                    {{ $t('Guardar') }}
                  </vs-button>
                </div>
              </div>
            </vx-card>
          </div>
          <div class="vx-col w-5/12">
            <vx-card class="mb-base" title="Avatar">
              <ImageDropzone ref="images" :files="files"></ImageDropzone>
            </vx-card>
          </div>
        </div>
      </form>
    </ValidationObserver>
  </div>
</template>

<script>
import ImageDropzone from '../ImageDropzone';
import { mapActions, mapGetters } from 'vuex';

export default {
  components: {
    ImageDropzone,
  },
  props: {
    user: {
      type: Object,
      required: true,
    },
  },
  data () {
    return {
      files: [],
      changePassword: false,
      userForm: {},
    };
  },
  created () {
    this.userForm = this.createUserForm(this.user);

    const files = new Array();
    if (this.userForm.avatar) {
      const image = {
        name: this.userForm.avatar,
        url: this.userForm.avatar,
        urlDelete: `/users/delete_image/${this.userForm.id}`,
      };
      files.push(image);
    }
    this.files = files;
  },
  computed: {
    ...mapGetters({
      languages: 'getLanguages',
    }),
    company: {
      get () {
        return this.user.company_id;
      },
      set (company) {
        this.userForm.company = company;
      },
    },
    passwordConfirmationRule () {
      return () => this.password === this.password_confirmation || 'Las contraseñas deben ser iguales';
    },
  },
  methods: {
    ...mapActions({
      editUser: 'editUser',
    }),
    createUserForm (user) {
      return {
        id: user.id,
        email: user.email,
        avatar: user.avatar,
        name: user.name,
        surname: user.surname,
        phone: user.phone,
        job: user.job,
        lang: user.lang,
        oldPassword: '',
        newPassword: '',
        newPassword_confirmation: '',
        company: user.company_id,
      };
    },
    handleSubmit () {
      this.$refs.form.validate().then((success) => {
        if (!success) {
          return;
        }

        this.submitted = true;

        const formData = this.createFormData();

        this.editUser({ user: formData, id: this.userForm.id });

        // Wait until the models are updated in the UI
        this.$nextTick(() => {
          this.$refs.form.reset();
          this.changePassword = false;
          this.userForm.oldPassword = '';
          this.userForm.newPassword = '';
          this.userForm.newPassword_confirmation = '';
        });
      });
    },
    createFormData () {
      const data = this.$refs.images.getFormData();
      data.append('name', this.userForm.name);
      data.append('email', this.userForm.email);
      data.append('job', this.userForm.job);
      data.append('phone', this.userForm.phone);
      data.append('surname', this.userForm.surname);
      data.append('lang', this.userForm.lang);

      if (this.changePassword === true) {
        data.append('oldPassword', this.userForm.oldPassword);
        data.append('newPassword', this.userForm.newPassword);
        data.append('newPassword_confirmation', this.userForm.newPassword_confirmation);
      }

      return data;
    },
  },
};
</script>
